export default __webpack_public_path__ + "static/media/YONI.b119c310.png";